<template>
  <div>
    <div class="grid-container mega" v-if="labels">
      <!-- Filter lev 1 : dropdowns -->
      <FocusLock
        :returnfocus="false"
        :disabled="!enableTopGroupLock()"
      >
        <div class="grid-x hide-for-print">

                <div class="mega__title medium-4 cell" :tabindex="selected && selected === item || !selected ? '0' : '-1'"
                v-for="(item, i) in selectItems"
                v-if="item.initial"
                :key="i"
                :class="{'mega__title--open': selected === item}"

                @click="toggleDropdown(item)"
                @keyup.enter="toggleDropdown(item)"
                @mouseover="dropdownAriaMouseEvent(item, false)"
                @mouseleave="dropdownAriaMouseEvent(item, true)"
                :aria-selected="dropdownAreaIsSelected(item)"
                :aria-label="dropdownAriaGetLabel(item)"
                :aria-roledescription="dropdownAriaGetRoleDescription()"

                >{{item.name}}</div>
        </div>

      <div class="grid-x hide-for-print" v-if="selected && selected.initial">
        <div class="mega__content cell">
          <!-- Filter lev 2 : tabs -->
          <ul
            class="mega__tabs grid-x"
            :class="tabGridClass"
            v-show="filter[selected.val].length > 1"
          >
            <li
              tabindex="0"
              class="mega__tab cell"
              v-for="tab in filter[selected.val]"
              :key="tab.tabGroupId"
              :class="{'mega__tab--open': selected.activeTab === tab.tabGroupId}"
              @click="selectTab(tab)"
              @keyup.enter="selectTab(tab)"
              @mouseover="tabAriaMouseEvent(tab, false)"
              @mouseleave="tabAriaMouseEvent(tab, true)"
              :aria-selected="tabAriaIsSelected(tab)"
              :aria-label="tabAriaGetLabel(tab)"
              :aria-roledescription="tabAriaGetRoleDescription(tab)">
              <span class="mega__tab-link">{{tab.name}}</span>
              </li>
            </ul>

          <!-- Filter lev 3 : option groups -->
          <ul class="mega__options"
            v-for="optionGroup in tabOptionGroups"
            :key="optionGroup.optionGroupId"
          >
            <!-- Filter lev 4 : options -->
            <li class="mega__option" tabindex="0"
              v-for="option in optionGroup.options"
              :key="option.id"
              :class="{'mega__option--title icon-circle-right': option.isTitle, 'mega__option--selected': option.isSelected}"
              @click="toggleOption(selected.val, option, optionGroup)"
              @keyup.enter="toggleOption(selected.val, option, optionGroup)"
              @mouseover="optionAriaMouseEvent(option, false)"
              @mouseleave="optionAriaMouseEvent(option, true)"
              :aria-selected="optionAriaIsSelected(option)"
              :aria-label="optionAriaGetLabel(option)"
              :aria-roledescription="optionAriaGetRoleDescription(option)">{{option.name}}</li>
           </ul>

           <div v-for="tab in filter[selected.val]">
             <p v-show="(selected.activeTab == '1' || selected.activeTab == '5') && (tab.name == 'Ledige' || tab.name == 'Unemployed')" class="mega__text">
               {{labels.disclaimerText}}<br />{{labels.disclaimerTextSecond}}
             </p>
           </div>

           <div class="mega__cta grid-x">
             <div class="cell large-4"></div>
               <div class="cell large-4">
                 <button class="button button__feedback"
                    @click="search(false)" @keyup.enter="search(false)"
                    :class="{'button__feedback--updating': forceWait || searching}"
                    :disabled="!isValid"
                    :title="!isValid ? this.labels.youMustSelect : ''"
                    :aria-roledescription="this.labels.ariaSearchButtonRoleDescription"
                 >
                   {{labels.showJobEffects}}
                   <div class="button__spinner loader__circle"></div>
                 </button>
               </div>
               <div class="cell large-4 text-left large-text-right">
                 <a v-if="isLoggedIn && searchResult !== null && isValid" class="button__label" tabindex="0" @click="openSaveDialog()" @keyup.enter="openSaveDialog()">{{labels.saveYourSearchCriteria}}</a>
               </div>
            </div>
          </div>

      </div>
    </FocusLock>

      <!-- Selected items Start -->
      <div class="grid-x" v-if="filter">

        <h2 class="h3 mega__selection-title show-for-small-only" v-if="isValid">{{labels.youHaveSelected}}</h2>
        <template
        v-for="(section, k) in selectItems"
        v-if="section.initial">

            <div class="mega__selection medium-4 small-12 cell" :key="k">

                <template v-if="section.anySelected">
                    <span class="show-for-small-only">{{section.selectionName}}</span>
                    <template v-if="showSelectionLabels()">
                        <span class="hide-for-small-only">{{section.selectionName}}</span><br>
                    </template>
                    <template v-for="tab in filter[section.val]">
                            <template v-for="group in tab.optionGroups">
                                <span
                                    class="mega__selection-item" tabindex="0"
                                    :title='item.namePicked'
                                    v-for="item in group.options"
                                    v-if="item.namePicked !== '' && item.isSelected"
                                    :key="item.id"
                                    @click="deselectItem(item, group, section.secondary)" @keyup.enter="deselectItem(item, group, section.secondary)"
                                >{{item.namePicked}}</span>
                            </template>
                        </template>
                </template>

                <template v-else>
                    <template v-if="showSelectionLabels()">
                        <span class="hide-for-small-only">{{section.selectionName}}<br>-</span>
                    </template>
                </template>
            </div>

        </template>


        <div class="mega__selection medium-12 text-right cell">
          <span
            class="mega__selection-reset hide-for-print" tabindex="0"
            v-if="isValid"
            @click="reset()" @keyup.enter="reset()"
          >{{labels.resetAllFilters}}</span>
          <!-- <span v-if="!isValid">-</span> -->
        </div>
      </div>
      <!-- Selected items End -->
    </div>

    <!-- Effect filter Start -->
    <div class="mega mega--effects" v-if="searchResult">
        <FocusLock
            :returnfocus="false"
            :disabled="!enableEffectGroupLock()"
        >

            <div class="grid-x align-center hide-for-print">
                <div class="cell" >
                    <h2 class="mega__delimit-title" >{{labels.filterDelimit}}</h2>
                </div>
            </div>

            <div class="grid-x align-center hide-for-print">
                <template  v-for="(item, i) in selectItems" v-if="!item.initial" >

                    <!-- Not dropdown -->
                    <div class="mega__title cell small-10 medium-4 "
                        v-if="!item.isDropdown"
                        :tabindex="selected && selected === item || !selected ? '0' : '-1'"
                        :key="i"
                        :class="{'mega__title--open': selected === item}"

                        @click="toggleDropdown(item)"
                        @keyup.enter="toggleDropdown(item)"
                        @mouseover="dropdownAriaMouseEvent(item, false)"
                        @mouseleave="dropdownAriaMouseEvent(item, true)"
                        :aria-selected="dropdownAreaIsSelected(item)"
                        :aria-label="dropdownAriaGetLabel(item)"
                        :aria-roledescription="dropdownAriaGetRoleDescription()"

                    >{{item.name}} <template v-if="selectedEffectCount > 0">({{ selectedEffectCount }} {{ labels.selected }})</template>
                    </div>

                    <!-- Dropdown -->
                    <div class="mega__dropdown-title cell small-10 medium-4 "
                        v-if="item.isDropdown"
                        :key="i"
                        >
                        <label class="show-for-sr" :for="item.optionGroupId">{{item.name}}</label>
                        <select
                            :id="item.optionGroupId"
                            :tabindex="selected && selected === item || !selected ? '0' : '-1'"
                            class= "mega__dropdown-select"
                            :key="item.optionGroupId"
                            @click="toggleDropdown(false)"
                            @keyup.enter="toggleDropdown(false)"
                            @change="toggleOptionDropdown(getFilterDropdownGroups(), $event)"
                        >
                            <option disabled value="all" selected>{{item.name}}</option>
                            <option :selected="option.isSelected" v-for="option in getFilterDropdownGroups()" :key="option.id" :value="option.id">{{option.name}}</option>
                        </select>
                        <label :for="item.optionGroupId" class="floating-label">{{item.name}}</label>
                    </div>

                </template>

                <!-- popupinfo for effect targets -->
                <popup-info-box
                    :text="this.labels.effectTargetMouseOver"
                    :popoverClasses="'popover--icon mega__popover'"
                    :infoIconTabIndex="infoIconTabIndexControl()"
                    @popupIsOpen="toggleDropdown(false)"
                >
                </popup-info-box>

            </div>

            <div class="grid-x align-center hide-for-print" v-if="selected && !selected.initial && !selected.isDropdown">

                <div class="mega__content medium-8 cell">

                <!-- Filter lev 2 : tabs -->
                <ul class="mega__tabs grid-x" :class="tabGridClass" v-show="filter[selected.val].length">
                    <li
                    class="mega__tab cell"
                    v-for="tab in filter[selected.val]"
                    :key="tab.tabGroupId"
                    :class="{'mega__tab--open': selected.activeTab === tab.tabGroupId}"
                    >
                    <a class="mega__tab-link"
                        tabindex="0"

                        @click="selectTab(tab)"
                        @keyup.enter="selectTab(tab)"
                        @mouseover="tabAriaMouseEvent(tab, false)"
                        @mouseleave="tabAriaMouseEvent(tab, true)"
                        :aria-selected="tabAriaIsSelected(tab)"
                        :aria-label="tabAriaGetLabel(tab)"
                        :aria-roledescription="tabAriaGetRoleDescription(tab)"

                    >{{tab.name}}</a>
                    </li>
                </ul>

                <!-- Effect targets -->
                <div v-if="selected.activeTab === 1">

                    <!-- Primary effect targets -->
                    <h4 class="mega__group-title">{{labels.filterEffectTargetsPrimary}}</h4>
                    <ul
                    class="mega__options"
                    v-for="optionGroup in getEffectTabOptionGroups(tabOptionGroups, false)"
                    :key="optionGroup.optionGroupId"
                    >
                    <li
                        class="mega__option" tabindex="0"
                        v-for="option in optionGroup.options"
                        :key="option.id"
                        :class="{'mega__option--title icon-circle-right': option.isTitle, 'mega__option--selected': option.isSelected}"

                        @click="toggleOption(selected.val, option, optionGroup)"
                        @keyup.enter="toggleOption(selected.val, option, optionGroup)"
                        @mouseover="optionAriaMouseEvent(option, false)"
                        @mouseleave="optionAriaMouseEvent(option, true)"
                        :aria-selected="optionAriaIsSelected(option)"
                        :aria-label="optionAriaGetLabel(option)"
                        :aria-roledescription="optionAriaGetRoleDescription(option)"

                    >{{option.name}}</li>
                    </ul>

                    <!-- Secondary effect targets -->
                    <div class="mega__content--secondary">
                    <h4 class="mega__group-title">{{labels.filterEffectTargetsSecondary}}</h4>
                    <ul
                        class="mega__options mega__options--secondary"
                        v-for="optionGroup in getEffectTabOptionGroups(tabOptionGroups, true)"
                        :key="optionGroup.optionGroupId"
                    >
                        <!-- Filter lev 4 : options -->
                        <li
                        class="mega__option" tabindex="0"
                        v-for="option in optionGroup.options"
                        :key="option.id"
                        :class="{'mega__option--title icon-circle-right': option.isTitle, 'mega__option--selected': option.isSelected}"

                        @click="toggleOption(selected.val, option, optionGroup)"
                        @keyup.enter="toggleOption(selected.val, option, optionGroup)"
                        @mouseover="optionAriaMouseEvent(option, false)"
                        @mouseleave="optionAriaMouseEvent(option, true)"
                        :aria-selected="optionAriaIsSelected(option)"
                        :aria-label="optionAriaGetLabel(option)"
                        :aria-roledescription="optionAriaGetRoleDescription(option)"
                        >{{option.name}}</li>
                    </ul>
                    </div>
                </div>

                <!-- Effect types -->
                <div v-else>
                    <ul
                    class="mega__options"
                    v-for="optionGroup in tabOptionGroups"
                    :key="optionGroup.optionGroupId"
                    >
                    <li
                        class="mega__option" tabindex="0"
                        v-for="option in optionGroup.options"
                        :key="option.id"
                        :class="{'mega__option--title icon-circle-right': option.isTitle, 'mega__option--selected': option.isSelected}"
                        @click="toggleOption(selected.val, option, optionGroup)"
                        @keyup.enter="toggleOption(selected.val, option, optionGroup)"
                    >{{option.name}}</li>
                    </ul>
                    <br>
                </div>


                <div class="mega__cta">
                    <button
                    class="button button__feedback" tabindex="0"
                    @click="search(true)" @keyup.enter="search(true)"
                    :class="{'button__feedback--updating': forceWait || searching}"
                    :disabled="!isValid"
                    :title="!isValid ? this.labels.youMustSelect : ''"
                    :aria-roledescription="this.labels.ariaSearchButtonRoleDescription"
                    >
                    {{labels.showJobEffects}}
                    <div class="button__spinner loader__circle"></div>
                    </button>
                </div>

                </div>

            </div>
        </FocusLock>

    </div>

    <!-- Effect filter End -->
  </div>

</template>

<script>
import { chain, find, each, some, union } from "lodash";
import { filter as _filter } from "lodash";
import PopupInfoBox from '../PopupInfoBox.vue';

import {
  getSelectedIds,
  getOptionsWithId,
  getDefaultSelectedOptions
} from "../../tools/tools.js";

export default {
  components: { PopupInfoBox },
  name: "searchfilter",
  data() {
    return {
      selectItems: [],
      forceWait: false,
      selected: false,
      lastSelected: false,
      isValid: false,
      isLoggedIn: window.vm.role !== "public",
      selectedEffectCount: "",
      lastHoverItem: false,
    };
  },
  watch: {
    filter: {
      handler() {
        // Since watcher is set to immediate it can be fired when filter is null
        if (this.filter === null) return;

        this.selectedEffectCount = this.countInSection(this.filter.effects, 1);
        this.anySelected();
        this.$store.commit("SEARCHFILTERDIRTY", true);
      },
      deep: true,
      immediate: true
    },
    searching: {
      handler() {
        if (!this.searching && !this.forceWait) {
          this.selected = false;
        }
      }
    }
  },
  computed: {
      filter:{
          get(){
              return this.$store.state.searchFilter;
          },
          set(value){
              this.$store.commit("SEARCHFILTER", value);
          }
      },
    tabOptionGroups() {
      let tabGroups = find(this.filter[this.selected.val], {
        tabGroupId: this.selected.activeTab
      });

      return tabGroups.optionGroups;
    },
    tabGridClass() {
      return "medium-up-" + this.filter[this.selected.val].length;
    },
    searching() {
      return this.$store.state.searching;
    },
    searchFilterDirty() {
      return this.$store.state.searchFilterDirty;
    },
    labels() {
      return this.$store.state.labels["pages.jobeffects"] || {};
    },
    searchResult() {
      return this.$store.state.search;
    },
    searchFilterDefaults() {
      return this.$store.state.searchFilterDefaults;
    }
  },
  mounted() {
    this.selectItems = [
      {
        name: this.labels.specifyTargetGroup,
        selectionName: this.labels.targetGroups,
        val: "targetgroups",
        activeTab: 1,
        activeTabHover: 1,
        secondary: false,
        anySelected: false,
        isDropdown: false,
        initial: true,
        ariaLabel: ""
      },
      {
        name: this.labels.filterTargetGroup,
        selectionName: this.labels.filterTargetGroup + ":",
        val: "other",
        activeTab: 4, // cannot be changed in backend
        activeTabHover: 4,
        secondary: true,
        anySelected: false,
        isDropdown: false,
        initial: true,
        ariaLabel: ""
      },
      {
        name: this.labels.specifyIntervention,
        selectionName: this.labels.interventions,
        val: "activities",
        activeTab: 1,
        activeTabHover: 1,
        secondary: false,
        anySelected: false,
        isDropdown: false,
        initial: true,
        ariaLabel: ""
      },
      {
        name: this.labels.filterEffectTargets,
        selectionName: "",
        val: "effects",
        activeTab: 1,
        activeTabHover: 1,
        secondary: false,
        anySelected: false,
        isDropdown: false,
        initial: false,
        ariaLabel: ""
      },
      {
        name: this.labels.filterGeograficalArea,
        selectionName: "",
        val: "filterGeographicalArea",
        activeTab: 5,
        activeTabHover: 5,
        secondary: false,
        anySelected: false,
        isDropdown: true,
        initial: false,
        ariaLabel: ""
      }
    ];
    this.anySelected();
  },
  methods: {

    toggleDropdown(item) {
      if (this.selected === item) {
        this.dropdownAriaSetLabel(item, this.labels.ariaDropdownUnselected);
        this.lastSelected = this.selected;
        this.selected = false;
      } else {
        this.dropdownAriaSetLabel(this.selected, this.labels.ariaDropdownUnselected);
        this.dropdownAriaSetLabel(item, this.labels.ariaDropdownSelected);
        this.lastSelected = this.selected;
        this.selected = item;
      }
    },
    dropdownAriaSetLabel(item, text){
        if(item)
        {
            item.ariaLabel = text;
        }
    },
    dropdownAriaMouseEvent(item, isLeaving)
    {
        var text = isLeaving ? this.labels.ariaDropdownUnselected : this.labels.ariaDropdownSelected;
        if(this.selected === item || (!this.selected && this.lastSelected === item))
        {
            return;
        }
        this.dropdownAriaSetLabel(item, text);
    },
    dropdownAreaIsSelected(item){
        var result = this.selected === item;
        return result;
    },
    dropdownAriaGetLabel(item){
        var result = item.ariaLabel;
        return result;
    },
    dropdownAriaGetRoleDescription(){
      var result = this.labels.ariaDropdownRoleDescription;
      return result;
    },

    selectTab(tab) {
        this.selected.activeTab = tab.tabGroupId;
    },
    tabAriaMouseEvent(tab, isLeaving) {
        this.selected.activeTabHover = isLeaving ? this.selected.activeTab : tab.tabGroupId;
    },
    tabAriaIsSelected(tab) {
        var result = this.selected.activeTab === tab.tabGroupId;
        return result;
    },
    tabAriaGetLabel(tab) {
        var result = this.selected.activeTab === tab.tabGroupId || this.selected.activeTabHover === tab.tabGroupId ? this.labels.ariaTabSelected: this.labels.ariaTabUnselected;
        return result;
    },
    tabAriaGetRoleDescription(tab) {
        var result = this.labels.ariaTabRoleDescription;
        return result;
    },

    toggleOption(dropdown, option, optionGroup) {
      this.lastHoverItem = false;
      option.isSelected = !option.isSelected;
      // Secondary tab has own selection logic :-s
      if (this.selected.secondary) {
        if (option.isTitle) {
          each(optionGroup.options, item => {
            item.isSelected = item.isTitle;
          });
        } else {
          secondaryTitleToggle(optionGroup);
        }
      }
    },
    toggleOptionDropdown(options, event)
    {
        var selectedId = event.target.value;
        each(options, (option) => {
            option.isSelected = (option.id === selectedId)
        });
        this.search(true);
    },
    optionAriaMouseEvent(option, isLeaving){
        this.lastHoverItem = isLeaving ? false: option;
    },
    optionAriaIsSelected(option){
        var result = option.isSelected;
        return result;
    },
    optionAriaGetLabel(option){
        var result = (option.isSelected && this.lastHoverItem !== option) || (this.lastHoverItem === option && !option.isSelected) ? this.labels.ariaOptionSelected : this.labels.ariaOptionUnselected;
        return result;
    },
    optionAriaGetRoleDescription(option){
        let tabGroups = find(this.filter[this.selected.val], {
        tabGroupId: this.selected.activeTab
      });
      var result = this.selected.secondary
      ? this.labels.ariaOptionRoleDescriptionUnselectOthers.replace("[tabname]", tabGroups.name)
      : this.labels.ariaOptionRoleDescription.replace("[tabname]", tabGroups.name);
      return result;
    },

    anySelected() {
      var any = false;
      each(_filter(this.selectItems, { initial: true }), section => {
        section.anySelected = this.anyInSection(this.filter[section.val]);
        if (!any && section.anySelected) {
          any = true;
        }
      });

      this.isValid = any;
      return any;
    },
    anyInSection(section) {
      return chain(section)
        .map(e => e.optionGroups)
        .flatten()
        .map(e => e.options)
        .flatten()
        .some(e => {
          return e !== null && e.isSelected && e.namePicked !== "";
        })
        .value();
    },
    countInSection(section, tabGroupId = 0){
      let result = chain(section)
        .filter(e => {
            return (tabGroupId !== 0 ? e.tabGroupId === tabGroupId : true)
        })
        .map(e => e.optionGroups)
        .flatten()
        .map(e => e.options)
        .flatten()
        .filter(e => {
          return e !== null && e.isSelected && e.namePicked !== "";
        })
        .value().length;
         return result;
    },
    reset() {
        let filter = _filter(this.filter, (val, key) => {
            return key !== "effects" && key !== "filterGeographicalArea"
        });
      each(filter, group => {
        each(group, tab => {
          each(tab.optionGroups, optionGroup => {
            each(optionGroup.options, option => {
              if(option.isSelected && option.namePicked !== "") {
                  option.isSelected = false;
              }
            });
            if (tab.isSecondary) {
              secondaryTitleToggle(optionGroup);
            }
          });
        });
      });
    this.$store.dispatch("getSearchFilter");
    this.$store.commit("SEARCH", null)
    },
    openSaveDialog() {
      this.$parent.$emit("openSaveDialog");
    },
    search(keepPosition) {
      this.$emit("searchEvent", {
        filter: this.filter,
        showEffectColumn: this.selectItems[2].anySelected
      });
      this.forceWait = true;
      setTimeout(e => {
        this.forceWait = false;
        if (!this.searching && !this.forceWait) {
          this.selected = false;
        }
        // update route query
        var queryData = { id: buildQueryList(this.filter) };
        if (this.$store.state.positiveOnly) queryData.positiveOnly = true;
        this.$router.push({ name: this.$route.name, query: queryData, params:{ savePosition: keepPosition } });
      }, 800);
    },
    deselectItem(item, group, isSecondary) {
      item.isSelected = false;
      if (isSecondary) {
        secondaryTitleToggle(group);
      }
      if (!this.anySelected()) {
        this.reset();
      } else {
        this.search(false);
      }
    },
    getEffectTabOptionGroups(group, isSecondary) {
      return _filter(group, { isSecondary: isSecondary });
    },
    getFilterDropdownGroups(){
        let _list =
        chain(this.filter.filterGeographicalArea)
        .map(e => e.optionGroups)
        .flatten()
        .map(e => e.options)
        .flatten()
        .value();
        return _list;
    },
    showSelectionLabels()
    {
        var result = this.selected !== false && this.selected.initial;
        return result;
    },
    enableTopGroupLock()
    {
        var result = this.selected !== false && this.selected.initial;
        return result;
    },
    enableEffectGroupLock()
    {
        var result = this.selected !== false && !this.selected.initial;
        return result;
    },
    infoIconTabIndexControl()
    {
        var result = this.selected !== false ? '-1' : '0';
        return result;
    }
  }
};

function secondaryTitleToggle(group) {
  // if no options are selected -> select title
  var titleItem = find(group.options, { isTitle: true });
  var anyOptionsSelected = some(group.options, {
    isTitle: false,
    isSelected: true
  });
  titleItem.isSelected = !anyOptionsSelected;
}

function buildQueryList(filter) {
  var list = [];
  each(filter, item => {
    list = union(getSelectedIds(item), list);
  });
  return list;
}
</script>



// WEBPACK FOOTER //
// src/components/jobeffects-search/SearchFilter.vue